import angular from "angular";
import $ from 'jquery';
import '../../../lib/jquery-table-exporter/table2CSV.js';
import '../../../lib/jquery-table-exporter/jquery.table2excel.js';

// angular visibility evaluator for ng-show/ng-hide on .isOrs ---
const orsExpr = /^\s*(!)?([A-Za-z0-9_]+)\.isOrs\s*$/;

const directive = ($rootScope) => {
    return {
        restrict: 'AE',
        scope: {
            tableIdToExport: '@',
            fileName: "@",
            exclude: "@",
            buttonName: "@"
        },
        template: require('./export-table-to-template.html'),
        link: function ($scope) {

            const angularIsOrsTest = ($node) => {
                // Check the node and its ancestors
                let $cur = $node;
                while ($cur && $cur.length) {
                    const showAttr = $cur.attr('ng-show') || $cur.attr('data-ng-show');
                    if (showAttr && orsExpr.test(showAttr)) {
                        const neg = !!showAttr.match(orsExpr)[1];
                        const shouldShow = neg ? !$rootScope.isOrs : $rootScope.isOrs;
                        if (!shouldShow) {
                            // ng-show is false => hidden
                            return false;
                        }
                    }
                    const hideAttr = $cur.attr('ng-hide') || $cur.attr('data-ng-hide');
                    if (hideAttr && orsExpr.test(hideAttr)) {
                        const neg = !!hideAttr.match(orsExpr)[1];
                        const shouldHide = neg ? !$rootScope.isOrs : $rootScope.isOrs;
                        if (shouldHide) {
                            // ng-hide is true => hidden
                            return false;
                        }
                    }
                    $cur = $cur.parent();
                }
                return true;
            };

            $scope.exportToExcel = function () {
                console.log("exportFile");
                $("#" + $scope.tableIdToExport).table2excel({
                    exclude: $scope.exclude ? $scope.exclude : ".noExport",
                    name: $scope.fileName ? $scope.fileName : "file",
                    fileext: ".xls",
                    filename: $scope.fileName ? $scope.fileName : "file",
                    angularIsOrsTest
                });
            };

            $scope.exportToCSV = function () {
                console.log("exportToCSV");
                $('#' + $scope.tableIdToExport).table2CSV({
                    separator: ',',
                    exclude: $scope.exclude ? $scope.exclude : ".noExport",
                    delivery: 'download',
                    filename: $scope.fileName ? $scope.fileName : "file",
                    angularIsOrsTest
                });
            };
        }
    };
}

angular
    .module('ui-common')
    .directive("exportTableTo", ['$rootScope', directive]);
